import { AppBar, Box, Toolbar, Typography } from '@mui/material';
import React from 'react';
import "../styles/Header.css"
import { useTranslation } from 'react-i18next';

export default function Header() {
  const { t } = useTranslation();

  return (
    // <header>
    //   <div className="container">
    //     <div className="header_cont">
    //       <div className="logo_cnt">
    //         <div className="logo">
    //           <img src="images/logo.png" className="img-fluid" alt="WBSEDCL" />
    //         </div>
    //         <div className="logo_liner">
    //           <p>WEST BENGAL STATE ELECTRICITY DISTRIBUTION COMPANY LIMITED</p>
    //         </div>
    //       </div>
    //       <div className="punch">
    //         <img src="images/header2.png" className="img-fluid" alt="WBSEDCL" />
    //       </div>
    //     </div>
    //   </div>
    // </header>

    <Box sx={{ flexGrow: 1 }}>

      <AppBar position="relative" sx={{ backgroundColor: '#fff', paddingY: 1 }} style={{zIndex: 999}}>

        <Toolbar>

          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>

            <div style={{ display: 'flex', alignItems: 'center' }}>

              <img src="images/logo.png" className="img-fluid" alt="WBSEDCL" />

              <div className="logo_liner">

                <p>{t("WEST BENGAL STATE ELECTRICITY DISTRIBUTION COMPANY LIMITED")}</p>

                <span>{t("A Government Of West Bengal Enterprise")} | {t("CIN")} : U40109WB2007SGC113473</span>

              </div>

            </div>

          </Typography>

          <img src="images/headerRight.png" className="img-fluid headerRight" alt="WBSEDCL" />

        </Toolbar>

      </AppBar>

    </Box>
  )
}